<template>
	<div>
		<div v-if="!esValidar" id="hgea"></div>
		<router-view style="margin-top: 130px; margin-bottom: 450px;"></router-view>
		<div v-if="!esValidar" id="fgea"></div>


		
		<div class="position-relative">
    <div id="alert" class="position-fixed top-50 start-50 translate-middle" style="z-index: 1090;"></div>
  </div>


	</div>
</template>

<script>
import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';


// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from 'bootstrap-vue';
Vue.use(LayoutPlugin);

// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin);

// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from 'bootstrap-vue';
Vue.use(CardPlugin);

// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from 'bootstrap-vue';
Vue.use(VBScrollspyPlugin);

// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from 'bootstrap-vue';
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);

//import Navbar from './components/Navbar';

export default {
	name: 'App',
	components: {
		//Navbar
	},
	computed:{
		esValidar() {
            return this.$route.path === "/validar";
        }
	}
};
</script>

<style lang="scss">
// Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead
$blue: #0a4e97 !default;
$primary: $blue !default;

// Import Bootstrap and BootstrapVue source SCSS files
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

// General style overrides and custom classes
</style>
